import cashforecasterIcon from "@/assets/cashforecaster.svg";

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-background">
      <img
        src={cashforecasterIcon}
        alt="Cash Forecaster"
        className="h-16 w-16 animate-pulse"
      />
      <p className="text-base font-medium text-muted-foreground">Loading…</p>
    </div>
  );
}
